import {createSlice} from '@reduxjs/toolkit'
import { fetchEmployment } from 'sr/redux/action/master/employmentAction'

interface employmentType {
    data:any,
    status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}
const initialState:employmentType = {
    data:null,
    status:'idle',
    error:null
}
const employmentSlice = createSlice({
    name:'employment',
    initialState,
    reducers:{},
    extraReducers:(builder)=> {
        builder.addCase(fetchEmployment.pending, (state)=> {
            state.status = 'loading'

        })
        builder.addCase(fetchEmployment.fulfilled, (state, action)=> {
            state.status = 'succeeded'
            state.data = action.payload
          })
        builder.addCase(fetchEmployment.rejected, (state, action)=> {
            state.status = 'failed'
            state.error = action.error.message || 'Failed to fetch business type data'
        })  
    },
})

export default employmentSlice.reducer;